import { compose, append, map, includes, ifElse, __, prop } from 'ramda';
import { Route } from 'react-router-dom';

import {
  HOME_PATH,
  SUCCESS_PATH,
  OFFER_SUCCESS_PATH,
  COMPONENTS_PATH,
  BILLING_PATH,
  LOGIN_PATH,
  INTERNAL_FOUR_O_FOUR,
  REGISTER_PATH,
  UNAVAILABLE_PATH,
  ALREADY_PREMIUM_PATH,
  MIGRATION_SUCCESS_PATH,
  REGISTRATION_PROMO_PATH,
  PRICING_PROMO_LANDING_PATH,
  PRICING_PROMO_SUCCESS_PATH,
  MIGRATION_LANDING_PATH,
} from 'app/router/constants/paths';
import withAuthorizedRoute from 'app/router/enhancers/withAuthorizedRoute';
import withLayout from 'app/components/layout/withLayout';
import { buildPathRegex } from 'app/router/helpers/buildPathRegex';
import {
  Components,
  Landing,
  Success,
  Billing,
  Login,
  ErrorPage,
  OfferUnavailable,
  Register,
  AlreadyPremium,
  MigrationSuccess,
  RegistrationPromo,
  PricingPromoLanding,
  MigrationLanding,
  PricingPromoSuccess,
} from 'app/router/LoadableComponents';
import createFactory from 'app/libs/createFactory';
import { availableRoutes } from 'config/selectors';
import NotFound from 'app/router/NotFound';

const componentsMap = {
  [COMPONENTS_PATH]: Components,
  [HOME_PATH]: Landing,
  [SUCCESS_PATH]: Success,
  [OFFER_SUCCESS_PATH]: Success,
  [BILLING_PATH]: Billing,
  [LOGIN_PATH]: Login,
  [REGISTER_PATH]: Register,
  [INTERNAL_FOUR_O_FOUR]: ErrorPage,
  [UNAVAILABLE_PATH]: OfferUnavailable,
  [ALREADY_PREMIUM_PATH]: AlreadyPremium,
  [MIGRATION_LANDING_PATH]: MigrationLanding,
  [MIGRATION_SUCCESS_PATH]: MigrationSuccess,
  [REGISTRATION_PROMO_PATH]: RegistrationPromo,
  [PRICING_PROMO_LANDING_PATH]: PricingPromoLanding,
  [PRICING_PROMO_SUCCESS_PATH]: PricingPromoSuccess,
};

const withLayoutMap = map(withLayout, componentsMap);
const withAuthMap = map(withAuthorizedRoute, withLayoutMap);

const componentByPath = ifElse(
  includes(__, window.etp.config.authorizedRoutes),
  prop(__, withAuthMap),
  prop(__, withLayoutMap),
);

const routes = compose(
  map(createFactory(Route)),
  append({ component: NotFound, key: 'error' }),
  map(path => ({
    key: path,
    exact: true,
    path: buildPathRegex(path),
    component: componentByPath(path),
  })),
)(availableRoutes);

export default routes;
